import React, { useEffect, useRef, useState } from "react";
import { useParams, useSearchParams } from "react-router-dom";
import API_BASE from "../config/api";

// Handles links sent from the auth admin panel:
//   /auth/remotelogin/:username/:hash
//   /auth/remotelogin?u=<username>&p=<hash>
function RemoteLogin() {
    const params = useParams();
    const [search] = useSearchParams();
    const [error, setError] = useState("");
    const started = useRef(false); // avoid double call in React StrictMode

    useEffect(() => {
        if (started.current) return;
        started.current = true;

        // useParams / URLSearchParams already decode %40, %2F, %24 etc.
        const username = params.username || search.get("u") || "";
        const hash = params.hash || search.get("p") || "";

        // Remove the credential from the address bar / history right away
        window.history.replaceState(null, "", "/auth/remotelogin");

        if (!username || !hash) {
            setError("Invalid login link.");
            return;
        }

        (async () => {
            try {
                const res = await fetch(`${API_BASE}/api/remote_login.php`, {
                    method: "POST",
                    headers: { "Content-Type": "application/json" },
                    body: JSON.stringify({ username, hash }),
                });

                const data = await res.json();

                if (data.success && data.user) {
                    localStorage.setItem("user", JSON.stringify(data.user));
                    window.location.replace("/");
                } else {
                    setError(data.message || "Login failed.");
                }
            } catch (err) {
                setError("Server error. Please try again.");
            }
        })();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    return (
        <div className="container py-5 d-flex justify-content-center">
            <div
                className="p-5 shadow-lg rounded-4 bg-white text-center"
                style={{
                    maxWidth: "500px",
                    width: "100%",
                    borderTop: "5px solid #1E49FF",
                }}
            >
                <img src="/logo.png" alt="Logo" style={{ width: "120px" }} className="mb-4" />

                {error ? (
                    <>
                        <h4 className="fw-bold text-danger mb-3">Login failed</h4>
                        <p className="text-muted">{error}</p>
                        <a href="/login" className="btn btn-primary rounded-pill px-4">
                            Go to Login
                        </a>
                    </>
                ) : (
                    <>
                        <div className="spinner-border text-primary mb-3" role="status" />
                        <h5 className="fw-bold" style={{ color: "#1E49FF" }}>
                            Signing you in...
                        </h5>
                    </>
                )}
            </div>
        </div>
    );
}

export default RemoteLogin;